import Moment from 'moment-timezone'

export default function timeZoneWrapper(...args) {
  return Moment(...args)
}



// WEBPACK FOOTER //
// ./src/lib/moment.js